// eslint-disable-next-line import/prefer-default-export
export const waitForObjectElement = (object, elementName, timeout = 30000) => {
    const startTime = Date.now();

    return new Promise((resolve, reject) => {
        let timeoutId;

        const cleanup = () => {
            if (timeoutId) {
                clearTimeout(timeoutId);
                timeoutId = undefined;
            }
        };

        const doCheck = () => {
            if (object[elementName]) {
                cleanup();
                resolve();
            } else if (Date.now() - startTime >= timeout) {
                cleanup();
                reject(new Error(`Timeout waiting for ${elementName}`));
            } else {
                timeoutId = setTimeout(doCheck, 100);
            }
        };

        doCheck();
    });
};
